import { mix } from 'polished';

/**
 * Mixes two colors together by a specified weight.
 *
 * @param color1:string - first color to mix
 * @param color2:string - second color to mix
 * @param weight:number - amount of color1 to mix into color2 [0, 100]
 */
export const interpolate = (color1: string, color2: string, weight = 50) => {
  const weightFraction = weight / 100;
  return mix(weightFraction, color1, color2);
};
